const gfieldInit = (field: HTMLElement) => {
  const allInput:HTMLInputElement = field.querySelector('input, select, textarea');
  const textInput:HTMLInputElement = field.querySelector('input, textarea');
  const inputContainer: HTMLElement = field.querySelector('.ginput_container');
  const fileInput: HTMLInputElement = field.querySelector('input[type="file"]');
  const uploadResult: HTMLElement = field.querySelector('.upload__result');

  const addRemoveButton = () => {
    if (!inputContainer.querySelector('.gfield_empty-field')) {
      const elem = document.createElement('div');
      elem.classList.add('gfield_empty-field');
      elem.innerHTML = '<i class="far fa-times"></i>';
      inputContainer.appendChild(elem);

      inputContainer.querySelector('.gfield_empty-field').addEventListener('click', () => {
        textInput.value = '';

        field.classList.remove('gfield_active');
        elem.remove();
      });
    }
  };

  // All inputs
  if (typeof allInput !== 'undefined' && allInput) {
    if (!allInput.classList.contains('gfield_active')) {
      allInput.addEventListener('change', () => {
        field.classList.add('gfield_active');
      });
    }
  }

  // Text input
  if (typeof textInput !== 'undefined' && textInput) {
    if (!textInput.classList.contains('gfield_active')) {
      textInput.addEventListener('keyup', () => {
        field.classList.add('gfield_active');

        addRemoveButton();
      });
    }
  }

  // File input
  if (typeof fileInput !== 'undefined' && fileInput) {
    fileInput.addEventListener('change', () => {
      uploadResult.innerHTML = fileInput.value;
    });
  }
};

export default gfieldInit;
